var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownChevron(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Down"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.65081 2.64453H8.81376C8.75684 2.64453 8.70327 2.67243 8.66978 2.71819L5.49902 7.08873L2.32827 2.71819C2.29478 2.67243 2.24121 2.64453 2.18429 2.64453H1.34724C1.27469 2.64453 1.23228 2.72712 1.27469 2.78627L5.20996 8.2115C5.35282 8.40792 5.64523 8.40792 5.78697 8.2115L9.72224 2.78627C9.76577 2.72712 9.72336 2.64453 9.65081 2.64453Z",
    fill: "#3D3D3D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownChevron);
export default __webpack_public_path__ + "static/media/downChevron.f1ad7f8ed812ebc70b074ed561f46bb3.svg";
export { ForwardRef as ReactComponent };